export default __webpack_public_path__ + "static/media/staff.aa0430bc.svg";